/**
 * Created by wwei on 2018-04-20.
 */

import request from 'superagent';

export function httpRequest(url, method, body) {
    return request(method.toUpperCase(), url)
        .withCredentials()
        .set('Content-Type', 'application/json')
        .send(body)
        .then(response => {
            return response;
        })
        .catch(error => {
            throw error;
        });
}


// WEBPACK FOOTER //
// ./src/common/functions/CustomRequest.js